module.exports = __webpack_public_path__ + "static/media/3-image.efcd0e7a.svg";